export default "__VITE_ASSET__BqQ$EUk2__"